export const Lozenge: React.FC = () => {
  return <></>;
};
